import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import type { ErrorRenderProps } from './error-render.types.ts';
import styles from './error-render.module.scss';

export function ErrorRender({ message, size = '2x' }: ErrorRenderProps) {
  return (
    <div className={styles.render}>
      <FontAwesomeIcon icon={faWarning} size={size} />
      <span>{message}</span>
    </div>
  );
}
